var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.evento.statusId != 2 && _vm.meta.statusId != 2)?_c('span',{staticClass:"text-danger float-left mr-1"},[_c('i',{staticClass:"fa fa-ban fa-lg icon-button",attrs:{"title":"Cancelar Meta"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarCancelar(_vm.meta.idMeta)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }